export default {
  'calander.guide': 'Руководство по календарю',
  'calander.redtheme': 'Красный цвет',
  'calander.graytheme': 'Серый цвет',
  'calander.greentheme': 'Зеленый цвет',
  'calander.bluetheme': 'Синий цвет',
  'calander.guidetitle': 'Цвета случаев под календарем следующие.',
  'calander.redthemeguide':
    'Этот цвет указывает на официальные праздники в соответствии с выбранной страной.',
  'calander.graythemeguide':
    'Этот цвет указывает на религиозные случаи выбранной страны.',
  'calander.greenthemeguide':
    'Этот цвет указывает на коренные случаи выбранной страны.',
  'calander.bluethemeguide':
    'Этот цвет указывает на традиционные местные случаи выбранной страны.',
  'calander.selectCountry': 'Название страны для отображения событий',
  'calander.changeDate': 'Изменить дату',
  'calander.changeType': 'Изменить тип',
  'calander.shamsi': 'Shamsi',
  'calander.miladi': 'Miladi',
  'calander.hijri': 'Hijri',
  'otheroption.otheroptions': 'Другие опции',
  'calendar.calculateDate': 'Расчеты даты',
  'otheroption.departuredate': 'Дата отправления',
  'otheroption.returndate': 'Дата возвращения',
  'otheroption.dayscount': 'Подсчет дней',
  'otheroption.calculate': 'Рассчитать',
  'otheroption.timeinterval': 'Временной интервал (возраст)',
  'otheroption.alertinsertresult.ru': 'Введенная дата недействительна.',
  'otheroption.untiltodayfuture': 'Время осталось с сегодняшнего дня.',
  'otheroption.untiltodaypast': 'Время, прошедшее до сегодняшнего дня.',
  'otheroption.otheroptionsguide1':
    'Выбрав страну в верхней части календаря, события, относящиеся к этой стране, будут установлены в календаре.',
  'otheroption.otheroptionsguide2':
    'При наведении указателя мыши на день все события этого дня будут отображаться в нижней части календаря.',
  'otheroption.otheroptionsguide3':
    'При нажатии на две даты будет отображен временной интервал между ними.',
  'otheroption.otheroptionsguide4':
    'Все события календаря представлены в виде списка в разделе событий календаря.',
};
